<div class="app-container">
  @if (loggedUser()) {
    <euroports-header/>

    <main>
      <router-outlet></router-outlet>
      <euroports-loading-indicator/>
    </main>
  } @else {
    <div class="full-screen-loader">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
